<template>
    <fb-form-body>
        <el-form :model="formData" :rules="rules" ref="form" label-width="100px" class="fb-form">

            <el-form-item label="员工姓名" prop="name" :error="formErrorMsg.name" class="fb-form-item">
                <el-input v-model="formData.name"></el-input>
            </el-form-item>

            <el-form-item label="员工工号" prop="jobNum" :error="formErrorMsg.jobNum"  class="fb-form-item">
                <el-input v-model="formData.jobNum" ></el-input>
            </el-form-item>

            <el-form-item label="所在部门" prop="departmentCode"  class="fb-form-item" >
                <org-cascader v-model="formData.departmentCode"></org-cascader>
            </el-form-item>


            <el-form-item label="岗位" prop="post"  class="fb-form-item" >
                <el-input v-model="formData.post" ></el-input>
            </el-form-item>


            <el-form-item label="状态" prop="status"  class="fb-form-item" >
                <dict-select type-flag="EMPLOYEE_STATUS" v-model="formData.status"> </dict-select>
            </el-form-item>


            <el-form-item>
                <el-button type="primary" @click="handleSubmit('form')">确定</el-button>
                <el-button @click="handleReset('form')">重置</el-button>
            </el-form-item>
        </el-form>
    </fb-form-body>
</template>

<script>


    import OrgCascader from "../../components/OrgCascader";
    import DictSelect from "../../components/DictSelect";
    export default {
        name: "RoleAdd",
        components: {DictSelect, OrgCascader,},
        data() {
            return {
                api:{
                   update:this.$api.employee.update
                },
                formErrorMsg:{name: '',
                    jobNum: ''},
                formData: {
                    code:'',
                    name: '',
                    post: '',
                    jobNum: '',
                    departmentCode: '',
                    status: '',
                },

                rules: {
                    name: [
                        {required: true, message: '请输入员工姓名', trigger: 'blur'},
                    ],
                    jobNum: [
                        {required: true, message: '请输入员工工号', trigger: 'blur'},
                    ],
                    departmentCode: [
                        {required: true, message: '请选择所在部门', trigger: 'blur'},
                    ],
                    status: [
                        {required: true, message: '请选择员工状态', trigger: 'blur'},
                    ]

                }
            }
        },
        methods: {
            handleSubmit(form) {

                let vm = this;
                vm.$refs[form].validate((valid) => {
                    if (valid) {
                        vm.$http.post(vm.api.update,this.$qs.stringify(this.formData)).then((resp)=>{

                            if(resp.data.status === 200){
                                vm.$message({
                                    type:'success',
                                    message: resp.data.desc
                                });
                                if(window.handleAddEmployee){
                                    window.handleAddEmployee();
                                }
                                vm.$router.cgBack();
                            }else if(resp.data.status === 400){

                                console.log(vm.$refs[form]);


                                resp.data.data.errorFields.forEach(function (a) {

                                    vm.formErrorMsg[a.name] = '';
                                    vm.$nextTick(()=>{
                                        vm.formErrorMsg[a.name] = a.message;
                                    });


                                });

                                if(resp.data.desc){
                                    vm.$message({
                                        type:"error",
                                        message: resp.data.desc
                                    });
                                }


                            }else{
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                })
                            }

                        });
                        return true;
                    } else {
                        return false;
                    }
                });

            },
            handleReset(form) {
                this.$refs[form].resetFields();
            }
        },
        created() {
            let vm = this;

            this.$http.post(this.$api.employee.detail,this.$qs.stringify(this.$route.query)).then(function (resp) {
                for(let key in resp.data.data){
                    for(let fKey in vm.formData){
                        vm.formData[fKey] = resp.data.data[key][fKey]

                    }
                }
            });

        }
    }
</script>

<style lang="scss" scoped>

    .fb-form-item {
        max-width: 500px;
    }

</style>